<script lang="ts">
  import { onMount } from 'svelte'
  import ButaneImage from '$lib/components/ButaneImage.svelte'
  import Button from '$lib/components/shadcn/button/button.svelte'
  import ButtonArrowUpSvg from '../../components/SVGs/ButtonArrowUpSVG.svelte'

  let reduceMotion = false

  onMount(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const syncPreference = () => (reduceMotion = mediaQuery.matches)
    syncPreference()
    mediaQuery.addEventListener('change', syncPreference)
    return () => mediaQuery.removeEventListener('change', syncPreference)
  })
</script>

<div class="mx-auto max-w-[1700px]">
  <section
    class="relative flex h-[900px] flex-col items-center justify-center overflow-hidden xl-mobile:h-[995px] md:h-[1000px] lg:h-[1200px]"
  >
    <div class="image-container">
      <ButaneImage
        width={786}
        height={700}
        src="Group 59.png"
        alt="icon"
        class="absolute left-1/2 top-[25%] z-[1] w-full -translate-x-1/2 scale-[2] sm:top-[15%] sm:z-[0] sm:scale-[1.7] md:top-[18%] md:h-[700px] md:w-[786px]"
        imgClass={reduceMotion ? '' : 'motion-safe:animate-[spin_60s_linear_reverse_infinite]'}
      />
      <ButaneImage
        width={786}
        height={700}
        src="Group 27.png"
        alt="icon"
        class="absolute left-1/2 top-[25%] z-[0] w-full -translate-x-1/2 rotate-[259deg] scale-[2] sm:top-[15%] sm:z-[1] sm:scale-[1.4] md:top-[18%] md:h-[700px] md:w-[786px]"
        imgClass={reduceMotion ? '' : 'motion-safe:animate-[spin_60s_linear_infinite]'}
      />
    </div>

    <div
      class="absolute inset-x-0 top-[26%] z-[2] flex w-full flex-col items-center space-y-10 md:space-y-20 lg-tablet:top-[30%]"
    >
      <h2 class="font-cirka text-[15vw] font-medium sm:text-[13vw] lg-tablet:text-[190px]">CDPS</h2>
      <p
        class="w-[90%] text-center font-graphik text-[5vw] leading-[150%] sm:w-[90%] sm:text-[4vw] lg-tablet:w-[536px] lg-tablet:text-[26px]"
      >
        Users retain the staking rights of ADA locked in Butane as collateral, a unique feature available exclusively on
        Cardano.
      </p>
      <Button
        variant="ghost"
        href="https://files.butane.dev/yellow-paper.pdf"
        target="_blank"
        class="flex h-[46px] w-[200px] items-center justify-between rounded-full bg-white shadow-sm  shadow-[#939EB8] transition-all duration-300 hover:scale-[1.01] hover:bg-white/80 active:scale-[.99]"
      >
        <p class="mr-2 font-graphik font-medium uppercase tracking-wide text-black">Read Yellowpaper</p>
        <ButtonArrowUpSvg fillStyles="black" />
      </Button>
    </div>
  </section>
</div>

<style>
  @media (min-width: 600px) {
    section {
      height: 1070px;
    }
  }
</style>
